module.exports = __webpack_public_path__ + "static/media/error-thumbnail-placeholder.1399af68.svg";